/*
 * Futsides · camisetas en miniatura (con nombre y dorsal)
 *
 * Pinta la camiseta de un jugador igual que el personalizador
 * (crearSVGJugadorConPath de la app): misma camiseta base, mismos patrones y
 * mismos elementos (cuello, mangas, hombros...). Para que una lista de cientos
 * de jugadores no pese, cada equipación se dibuja UNA vez como imagen y encima
 * solo se escriben el nombre y el dorsal.
 *
 * API:  FutsidesCamisetaMini.pintar(elemento, {nombre, dorsal}, kit, anchoPx)
 *       FutsidesCamisetaMini.asegurarFuente(familia)  -> Promise
 * Datos: /a/api/camiseta-base-svg, /a/api/patrones, /a/api/fuentes (los mismos del editor)
 */
(function () {
  "use strict";
  if (window.FutsidesCamisetaMini) return;

  var API = window.FS_API_BASE || "/a/api";
  var baseP = null, patronesP = null, fuentesP = null;
  var kits = {};          // clave -> Promise<url de la imagen>
  var fuentesPedidas = {}; // familia -> Promise

  function get(url, comoTexto) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status + " " + url);
      return comoTexto ? r.text() : r.json();
    });
  }
  function base() {
    return baseP || (baseP = get(API + "/camiseta-base-svg", true).then(function (t) {
      var svg = new DOMParser().parseFromString(t, "image/svg+xml").querySelector("svg");
      return svg ? svg.innerHTML : "";
    }));
  }
  function patrones() {
    return patronesP || (patronesP = get(API + "/patrones").catch(function () { return []; }));
  }
  function fuentes() {
    return fuentesP || (fuentesP = get(API + "/fuentes").then(function (d) { return (d && d.fuentes) || d || []; }).catch(function () { return []; }));
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // ── Camiseta sin textos (mismo algoritmo que crearSVGJugadorConPath) ────────
  function cuerpoCamiseta(contenido, pats, c) {
    var defs = "";
    var fill = c.primario || "#ffffff";
    if (c.patron && c.patron !== "liso") {
      var p = (pats || []).find(function (x) { return x.slug === c.patron; });
      if (p && p.svgContent) {
        var w = p.patternWidth || 360, h = p.patternHeight || 500;
        var dentro = p.svgContent.replace(/\{PRIMARIO\}/g, c.primario).replace(/\{SECUNDARIO\}/g, c.secundario);
        defs = '<pattern id="pd" patternUnits="userSpaceOnUse" width="' + w + '" height="' + h + '">' + dentro + "</pattern>";
        fill = "url(#pd)";
      }
    }
    var s = contenido.replace(/<text[\s\S]*?<\/text>/g, "");
    s = s.replace(/style="fill:#ffffff;"/g, 'style="fill:' + fill + ';"');
    if (c.borde) {
      s = s.replace(/style="fill:transparent;z-index:1;" stroke="transparent"/g, 'style="fill:transparent; z-index:1;" stroke="' + (c.colorBorde || "#000000") + '"');
    }
    var t = c.terciario;
    [
      ["cuello", c.cuello, c.colorCuello || t],
      ["final-camiseta", c.finalCamiseta, c.colorFinalCamiseta || t],
      ["mangas", c.mangas, c.colorMangas || t],
      ["hombros", c.hombros, c.colorHombros || t],
      ["laterales-cuerpo", c.lateralesCuerpo, c.colorLateralesCuerpo || t],
      ["espalda", c.espalda, c.colorEspalda || t],
      ["final-mangas", c.finalMangas, c.colorFinalMangas || t],
      ["mangas-largas", c.mangasLargas, c.primario],
      ["espalda-alta", c.espaldaAlta, c.colorEspaldaAlta || t],
      ["espalda-baja", c.espaldaBaja, c.colorEspaldaBaja || t],
    ].forEach(function (e) {
      var color = e[1] ? e[2] : "transparent";
      s = s.replace(new RegExp('(class="' + e[0] + '"[^>]*)fill="[^"]*"', "g"), "$1fill=\"" + color + "\"");
      s = s.replace(new RegExp('(class="' + e[0] + '"[^>]*style="[^"]*fill:)[^;"]*(;[^"]*)', "g"), "$1" + color + "$2");
      s = s.replace(new RegExp('(id="' + e[0] + '"[^>]*)fill="[^"]*"', "g"), "$1fill=\"" + color + "\"");
      if (e[0] === "mangas-largas") {
        s = s.replace(e[1] ? /stroke-opacity:0/g : /stroke-opacity:1/g, e[1] ? "stroke-opacity:1" : "stroke-opacity:0");
        s = s.replace(/id="mangas-largas-relleno"([^>]*)fill="[^"]*"/, 'id="mangas-largas-relleno"$1fill="' + color + '"');
        s = s.replace(/fill="[^"]*"([^>]*)id="mangas-largas-relleno"/, 'fill="' + color + '"$1id="mangas-largas-relleno"');
        s = s.replace(/(id="mangas-largas-relleno"[^>]*style="[^"]*fill:)[^;"]*([;"])/g, "$1" + color + "$2");
      }
    });
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 500"><defs>' + defs + "</defs>" + s + "</svg>";
  }

  var CLAVES_KIT = ["primario", "secundario", "terciario", "patron", "borde", "colorBorde", "cuello", "colorCuello",
    "finalCamiseta", "colorFinalCamiseta", "mangas", "colorMangas", "hombros", "colorHombros", "lateralesCuerpo",
    "colorLateralesCuerpo", "espalda", "colorEspalda", "finalMangas", "colorFinalMangas", "mangasLargas",
    "espaldaAlta", "colorEspaldaAlta", "espaldaBaja", "colorEspaldaBaja"];

  function imagenKit(kit) {
    var clave = CLAVES_KIT.map(function (k) { return kit[k]; }).join("|");
    if (!kits[clave]) {
      kits[clave] = Promise.all([base(), patrones()]).then(function (r) {
        var blob = new Blob([cuerpoCamiseta(r[0], r[1], kit)], { type: "image/svg+xml" });
        return URL.createObjectURL(blob);
      });
    }
    return kits[clave];
  }

  // ── Fuentes (Google o subidas a la app), igual que ensureSingleFont ────────
  function asegurarFuente(familia) {
    if (!familia) return Promise.resolve();
    if (fuentesPedidas[familia]) return fuentesPedidas[familia];
    fuentesPedidas[familia] = fuentes().then(function (lista) {
      var f = lista.find(function (x) { return x.familia === familia || x.id === familia || x.nombre === familia; });
      if (f && f.system) return;
      if (f && f.archivoUrl) {
        var url = f.archivoUrl.replace(/^\/api\//, API + "/");
        return new FontFace(familia, "url(" + url + ")").load().then(function (ff) { document.fonts.add(ff); }).catch(function () {});
      }
      var id = "fs-fuente-" + familia.replace(/\s+/g, "-").toLowerCase();
      if (document.getElementById(id)) return;
      var link = document.createElement("link");
      link.id = id; link.rel = "stylesheet";
      link.href = "https://fonts.googleapis.com/css2?family=" + encodeURIComponent(familia).replace(/%20/g, "+") + "&display=swap";
      document.head.appendChild(link);
      return new Promise(function (ok) { link.onload = link.onerror = function () { document.fonts.load("20px '" + familia + "'").then(ok, ok); }; });
    });
    return fuentesPedidas[familia];
  }

  // ── Camiseta completa: imagen de la equipación + nombre y dorsal encima ────
  function pintar(el, jugador, kit, ancho) {
    ancho = ancho || 64;
    var alto = Math.round(ancho * 500 / 360);
    var sep = parseInt(kit.separacionDorsal, 10) || 0, sepND = parseInt(kit.separacionNombreDorsal, 10) || 0;
    var yD = (kit.espalda ? 240 : 185) + sep + sepND;
    var yN = (kit.espalda ? 120 : 85) + sep - sepND;
    var fuente = kit.fuente || "Anton";
    asegurarFuente(fuente);
    return imagenKit(kit).then(function (url) {
      el.innerHTML =
        '<svg class="fs-mini" viewBox="0 0 360 500" width="' + ancho + '" height="' + alto + '" role="img" aria-label="' + esc(jugador.nombre) + '">' +
        '<image href="' + url + '" x="0" y="0" width="360" height="500"/>' +
        '<text x="51%" y="' + yN + '" text-anchor="middle" font-family="\'' + esc(fuente) + '\', sans-serif" font-weight="400" font-size="' + (kit.tamanoNombre || 45) + 'px" fill="' + esc(kit.colorNombre || "#ffffff") + '">' + esc(jugador.nombre) + "</text>" +
        '<text x="51%" y="' + yD + '" text-anchor="middle" font-family="\'' + esc(fuente) + '\', sans-serif" font-weight="400" font-size="' + (kit.tamanoDorsal || 80) + 'px" fill="' + esc(kit.colorDorsal || "#ffffff") + '">' + esc(jugador.dorsal) + "</text>" +
        "</svg>";
    });
  }

  // ── Catálogo de jugadores (futsides-jugadores-camisetas.json) ──────────────
  var catalogoP = null;
  function sinTildes(s) { return String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toUpperCase(); }
  function catalogo() {
    if (catalogoP) return catalogoP;
    var url = window.FS_JUGADORES_URL;
    if (!url) return Promise.reject(new Error("Falta FS_JUGADORES_URL"));
    catalogoP = get(url).then(function (d) {
      var equiposPorPersona = {};
      d.jugadores.forEach(function (j) { (equiposPorPersona[j.id] = equiposPorPersona[j.id] || {})[j.e] = 1; });
      var vistos = {};
      d.lista = [];
      d.jugadores.forEach(function (j) {
        var clave = j.id + "|" + j.k + "|" + j.n + "|" + j.d, eq = d.equipos[j.e];
        if (vistos[clave]) {
          var v = vistos[clave];
          v.equipos.push(eq.t); v.clubes.push(eq.c || ""); v.anios = v.anios.concat(eq.y || []);
          if (!j.s) v.suplente = false;
          return;
        }
        var o = {
          id: j.id, nombre: j.n, quien: j.q, dorsal: j.d, linea: j.l,
          kit: d.kits[j.k], equipos: [eq.t], clubes: [eq.c || ""], anios: (eq.y || []).slice(),
          suplente: !!j.s, peso: Object.keys(equiposPorPersona[j.id]).length,
        };
        vistos[clave] = o;
        d.lista.push(o);
      });
      d.lista.forEach(function (o) {
        o.equipo = o.equipos[0];
        o.buscar = sinTildes([o.nombre, o.quien].concat(o.equipos, o.clubes).join(" "));
      });
      d.lista.sort(function (a, b) { return b.peso - a.peso || a.nombre.localeCompare(b.nombre) || a.equipo.localeCompare(b.equipo); });
      // rango = qué camiseta es de ese jugador (0 = la primera). Sirve para que,
      // sin buscar nada, salga una camiseta de cada jugador antes que repetirlos.
      var n = {};
      d.lista.forEach(function (o, i) { o.orden = i; o.rango = n[o.id] = (n[o.id] === undefined ? 0 : n[o.id] + 1); });
      return d;
    });
    return catalogoP;
  }
  // Años en la búsqueda: "2009" = cualquier temporada que lo toque (2008/09 y 2009/10),
  // "2008/09", "08/09", "2008-09" = esa temporada. Devuelve [{ini, fin, exacta}] y el resto del texto.
  function siglo(a) { return a.length === 4 ? +a : (+a >= 50 ? 1900 : 2000) + +a; }
  function leerAnios(q) {
    var anios = [], resto = [];
    q.forEach(function (t) {
      var m = t.match(/^(\d{2}|\d{4})[\/-](\d{2}|\d{4})$/), y = t.match(/^(19|20)\d{2}$/);
      if (m) { var i = siglo(m[1]); anios.push({ ini: i, fin: i + 1, exacta: true }); }
      else if (y) anios.push({ ini: +t, fin: +t, exacta: false });
      else resto.push(t);
    });
    return { anios: anios, resto: resto };
  }
  function encajaAnio(o, a) {
    return o.anios.some(function (r) {
      return a.exacta ? (r[0] === a.ini && r[1] === a.fin) || (r[0] === r[1] && (r[0] === a.ini || r[0] === a.fin))
                      : r[0] <= a.ini && a.ini <= r[1];
    });
  }
  var ORDEN_LINEA = { POR: 0, DEF: 1, MED: 2, DEL: 3 };
  // linea: "DEF" = solo esa línea, "!POR" = todas menos esa, null = todas
  function buscar(lista, texto, linea) {
    var q = sinTildes(texto).trim().split(/\s+/).filter(Boolean);
    var l = leerAnios(q), palabras = l.resto, conAnio = l.anios.length > 0;
    var no = linea && linea.charAt(0) === "!" ? linea.slice(1) : null;
    var res = lista.filter(function (o) {
      if (no ? o.linea === no : linea && o.linea !== linea) return false;
      // Sin buscar nada solo salen los del póster; buscando, también los suplentes de esa plantilla
      if (o.suplente && !q.length) return false;
      if (conAnio && !l.anios.every(function (a) { return encajaAnio(o, a); })) return false;
      for (var i = 0; i < palabras.length; i++) if (o.buscar.indexOf(palabras[i]) === -1) return false;
      return true;
    });
    if (!q.length) res.sort(function (a, b) { return a.rango - b.rango || a.orden - b.orden; });
    // Con año: la plantilla de esa temporada equipo a equipo, titulares primero y por líneas (POR, DEF, MED, DEL)
    else if (conAnio) res.sort(function (a, b) {
      return a.equipo.localeCompare(b.equipo) || (a.suplente - b.suplente) || (ORDEN_LINEA[a.linea] - ORDEN_LINEA[b.linea]) || ((+a.dorsal || 99) - (+b.dorsal || 99)) || a.orden - b.orden;
    });
    // Buscando sin año: titulares antes que suplentes, y todas las camisetas de cada uno juntas
    else res.sort(function (a, b) { return (a.suplente - b.suplente) || a.orden - b.orden; });
    return res;
  }

  // Pinta solo lo que entra en pantalla
  var io = "IntersectionObserver" in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      var o = e.target.__fsJugador;
      if (o) pintar(e.target, o, o.kit, parseInt(e.target.getAttribute("data-ancho"), 10) || 64);
    });
  }, { rootMargin: "200px 0px" }) : null;
  function pintarCuandoSeVea(el, o, ancho) {
    el.__fsJugador = o;
    el.setAttribute("data-ancho", ancho || 64);
    if (io) io.observe(el); else pintar(el, o, o.kit, ancho);
  }

  window.FutsidesCamisetaMini = {
    pintar: pintar, pintarCuandoSeVea: pintarCuandoSeVea, asegurarFuente: asegurarFuente,
    catalogo: catalogo, buscar: buscar, esc: esc,
  };
})();
